<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-1 md:block" />
            <div class="col-span-12 text-left md:col-span-10">
                <h2>Přejmenovávání</h2>
                <div class="mt-5 mb-5">
                    <img
                        src="../../public/img/articles/prejmenovavani.webp"
                        alt=""
                        class="mb-1 aspect-auto w-full object-cover"
                    />
                    <span class="source"
                        >Tato tabulka v dnešní ulici Karla Zemana se na svém
                        místě „ohřála“ sotva 3 měsíce. / Zdroj: Marek
                        Lašťovka</span
                    >
                </div>
                <p class="mb-5 font-bold">
                    K přejmenovávání ulic v minulosti docházelo zejména se
                    změnou jejich účelu nebo spojením s jinou komunikací.
                    Některé pražské ulice během staletí vystřídaly i deset
                    různých názvů, jiné si ten svůj drží už od středověku.
                    Podívejme se, proč ke změnám docházelo nejčastěji, a které
                    ulice se přejmenovávaly nejvíce.
                </p>

                <p class="mb-5">
                    Pro přejmenování ulice jsou tři nejčastější důvody. V
                    nejstarších dobách se názvy měnily podle účelu prostranství
                    (trhy a zboží na nich) či majitelů místních domů. Jedná se o
                    „neúřední“ změnu názvu – ten se měnil podle toho, jak jej
                    užívali lidé a jak se odrazil v pramenech, a nešlo tedy o
                    přejmenování v dnešním slova smyslu. Některé ulice či jejich
                    části však díky tomu získaly v průběhu staletí pozoruhodný
                    počet názvů. Nejvíce jich nastřádala ulice
                    <span class="italic">Pařížská, </span>
                    i když zde je situace způsobena asanací starší zástavby, a
                    jedná se tak o názvy různých lokalit předcházejících zhruba
                    dnešní podobě
                    <span class="italic">Pařížské.</span>
                    Dále pak následují ulice
                    <span class="italic">Opletalova</span>
                    (nesla názvy
                    <span class="italic"
                        >Bosácká, Turkova, Mariánská, Sanytrovny, Chudobická, V
                        Chudobicích, U hradeb, Dolní Hradební, Cíp, Lützowova,
                        Beethoveenova</span
                    >) a
                    <span class="italic">Havelská</span>
                    (nesla názvy
                    <span class="italic"
                        >Nové tržiště, Svatohavelský trh, Mezi koláři, V
                        tandléřích, Tandlmark, Havelské náměstí, Uhelná, Zelný
                        či Zelený trh, Eberhardova</span
                    >), avšak ani tyto názvy nelze vztáhnout na celou dnešní
                    ulici.
                </p>

                <p class="mb-5">
                    Druhým důvodem pro větší míru přejmenovávání bývalo
                    spojování a rozdělování komunikací. Posledním pak jsou
                    politicky motivované změny názvů, a to zejména hlavních tříd
                    v jednotlivých pražských čtvrtích. U většiny ulic se však
                    tyto důvody kombinují. Ulice „nejpostiženější“
                    přejmenováváním tak vystřídaly název 8–11×. Jsou to
                    <span class="italic">Rašínovo nábřeží</span>
                    (8 názvů se vystřídalo na jeho jednotlivých částech 11×),
                    <span class="italic">Zenklova</span>
                    (9 názvů se zde vystřídalo 10×),
                    <span class="italic">Wilsonova</span>
                    (7 názvů 10×),
                    <span class="italic">Jugoslávských partyzánů</span>
                    (8 názvů 9×),
                    <span class="italic">Patočkova</span>
                    (7 názvů 9×),
                    <span class="italic">Musílkova</span>
                    (6 názvů 9×),
                    <span class="italic"
                        >Zbuzkova, Masarykovo nábřeží a Evropská</span
                    >
                    (všechny 7 názvů 8×).
                </p>

                <p class="mb-10 sm:mb-25">
                    Svůj název změnilo celkem více než 3000 ulic, tedy ani ne
                    polovina, ostatní mají svůj původní název. Nezměněné názvy
                    nesou zejména nové ulice v nové zástavbě, v centru města se
                    jedná spíše o výjimky (zde se názvy měnily nejčastěji z
                    prvně uvedeného důvodu, onu výjimku představuje pak ulice
                    <span class="italic">Dlouhá</span>
                    mající svůj název již od 14. století). Ulice v obcích
                    připojených k Praze po roce 1960 změnily název většinou
                    pouze jedenkrát, a to právě v důsledku připojení té které
                    obce k Praze a tím vzniklé duplicity jmen.
                </p>

                <!-- next chapters -->
                <div class="mb-10 flex justify-between border-t-1 pt-5">
                    <p class="mb-5 w-1/2 border-r-1 font-bold">
                        <nuxt-link
                            to="/clanky/pravopis-a-jazykova-spravnost-nazvu"
                            class="flex justify-start underline"
                        >
                            <img
                                src="../../public/img/left-arrow.png"
                                alt=""
                                class="order-1 mr-2 inline h-5 w-5"
                            />
                            <span class="order-2 mr-2"
                                >Pravopis a jazyková správnost názvů</span
                            >
                        </nuxt-link>
                    </p>
                    <p class="mb-5 w-1/2 text-right font-bold">
                        <nuxt-link
                            to="/clanky/puvody-nazvu-a-jech-cetnost"
                            class="flex justify-end underline"
                        >
                            <span class="order-1 ml-2"
                                >Původy názvů a jejich četnost</span
                            >
                            <img
                                src="../../public/img/right-arrow.png"
                                alt=""
                                class="order-2 ml-2 inline h-5 w-5"
                            />
                        </nuxt-link>
                    </p>
                </div>
            </div>
            <div class="hidden md:col-span-1 md:block" />
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
